<swiper-container ushSwiperElement [config]="swiperConfig" init="false">
  <swiper-slide *ngFor="let laurel of laurels" lazy="true">
    <ush-ui-movie-laurel [laurel]="laurel"></ush-ui-movie-laurel>
  </swiper-slide>
</swiper-container>
